var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.info.image,"alt":""}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('v-h5Mtml',{attrs:{"content":_vm.info.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }